import category from '@/api/categories'
import orders from '@/api/orders/'
import accountAPI from '@/api/accounts'
import moment from 'moment'

export const getCategoriesAPI = ({ commit }) => {
  // category.getCategories(category => {
  //   commit('setCategories', category.data.data.catalog)
  // })
}

export const getCategoryByID = ({ commit, state }, param) => {
  category.getCategoryById(category => {
    return category.data
  }, param)
}

export const addCategory = ({ commit, state, dispatch }, param) => {
  category.addCategory(category => {
    dispatch('getCategoriesAPI', '')
  }, param)
}

export const updateCategory = ({ commit, state, dispatch }, param) => {
  category.updateCategory(category => {
    dispatch('getCategoriesAPI', '')
  }, param)
}

export const setOrderQuery = ({ commit, dispatch }, param) => {
  let newQuery = ''
  if (param.keyword) {
    newQuery += 'keyword=' + param.keyword
  }
  if (param.date1 && param.createDate === true) {
    if (newQuery) {
      newQuery += '&'
    }
    newQuery += 'date1=' + moment(param.date1).format('YYYY-MM-DD')
  }
  if (param.date2 && param.createDate === true) {
    if (newQuery) {
      newQuery += '&'
    }
    newQuery += 'date2=' + moment(param.date2).format('YYYY-MM-DD')
  }
  if (param.update_date_1 && param.updateDate === true) {
    if (newQuery) {
      newQuery += '&'
    }
    newQuery += 'update_date_1=' + moment(param.update_date_1).format('YYYY-MM-DD')
  }
  if (param.update_date_2 && param.updateDate === true) {
    if (newQuery) {
      newQuery += '&'
    }
    newQuery += 'update_date_2=' + moment(param.update_date_2).format('YYYY-MM-DD')
  }
  if (param.orderType) {
    if (newQuery) {
      newQuery += '&'
    }
    newQuery += 'order_type=' + param.orderTypeChoice
  }
  if (param.orderStatus) {
    if (newQuery) {
      newQuery += '&'
    }
    newQuery += 'order_status=' + param.orderStatusChoice
  }
  if (newQuery) {
    newQuery += '&'
  }
  if (param.page === 0) {
    param.page = 1
  }
  newQuery += '_page=' + param.page
  newQuery += '&_limit=' + param.limit
  newQuery += '&_sort=' + param.sort
  newQuery += '&_order=' + param.order
  param.query = '?' + newQuery
  commit('setOrderSearch', param)
  dispatch('getOrdersList', param.query)
}

export const getOrdersList = ({ commit }, param) => {
  orders.getOrders(ordersList => {
    commit('setOrderResult', ordersList.data.data)
  }, param)
}

export const getBusinessId = ({ commit }) => {
  accountAPI.getBusinessId(business => {
    commit('setBusinessId', business)
  })
}

export const getCountryList = ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    orders.getCountryList(result => {
      resolve(result.data.data)
    }, param)
  })
}

export const getProvinceList = ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    orders.getProvinceList(result => {
      resolve(result.data.data)
    }, param)
  })
}

export const getDistrictList = ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    orders.getDistrictList(result => {
      resolve(result.data.data)
    }, param)
  })
}

export const getSubDistrictList = ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    orders.getSubDistrictList(result => {
      resolve(result.data.data)
    }, param)
  })
}

export const getAllProductList = ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    orders.getAllProductList(result => {
      commit('setAllProductList', result.data.data)
      resolve(result.data.data)
    }, param)
  })
}

export const getAddProductsVariant = ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    orders.getAddProductsVariant(result => {
      resolve(result.data.data)
    }, param)
  })
}

export const getOrderDetailsByOrdersId = ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    orders.getOrderDetailsByOrdersId(result => {
      resolve(result.data.data)
    }, param)
  })
}

export const addNewOrder = ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    orders.addNewOrder(result => {
      resolve(result.data)
    }, param)
  })
}

export const getPostCode = ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    orders.getPostCode(result => {
      resolve(result.data.data)
    }, param)
  })
}

export const updateNewOrder = ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    orders.updateNewOrder(result => {
      resolve(result.data)
    }, param)
  })
}

export const getActiveDomain = ({ commit }) => {
  return new Promise((resolve, reject) => {
    orders.getActiveDomain(result => {
      resolve(result.data.data)
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/actions.js